<!-- 行业动态 -->
<template>
  <div class="frame">
    <Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="wrap">
      <div class="left">
        <div class="in">
          <LinkMap />
        </div>
      </div>
      <div class="right">
        <div class="label-title">
          <span>{{ $route.name }}</span>
        </div>
        <div class="list">
          <div
            class="item"
            v-for="item in list"
            :key="item.id"
            @click="navToDetail(item)"
          >
            <div class="img" v-show="item.newsImageUrl">
              <img :src="URL + item.newsImageUrl" class="post" />
            </div>
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="intro">{{ item.description }}</div>
              <div class="time">
                {{ (item.publishTime || item.createTime).split(" ")[0] }}
              </div>
            </div>
          </div>
        </div>
        <div class="empty" v-show="list.length == 0">
          <el-empty description="暂无相关资讯"></el-empty>
        </div>
        <el-pagination
          class="pagination"
          background
          :hide-on-single-page="totalData < 11"
          @current-change="currentChange"
          :current-page.sync="queryParams.pageIndex"
          :page-size="queryParams.pageSize"
          layout="prev, pager, next"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../components/breadCrumb.vue";
import LinkMap from "../components/linkMap.vue";
import { URL } from "../util/config";
export default {
  components: { Breadcrumb, LinkMap },
  data() {
    return {
      URL,
      breadcrumbs: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        typeName: "行业动态",
      },
      list: [],
      totalData: 0,
    };
  },
  created() {
    this.breadcrumbs = [
      { path: "/", name: "首页" },
      { name: this.$route.name },
    ];
    this.getList();
  },
  methods: {
    currentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    async getList() {
      let res = await this.$api.getNewsList(this.queryParams);
      this.list = res.data.list;
      this.totalData = res.data.total;
    },
    navToDetail(item) {
      this.$router.push("/newDetail" + this.$route.path + "/" + item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
  width: 1200px;
  margin: 0 auto;

  .left {
    width: 25%;
    padding: 0 20px;
    box-sizing: border-box;
    position: relative;

    .in {
      position: sticky;
      left: 0;
      top: 30px;
      background-color: #fff;
    }
  }
  .right {
    width: 75%;
    min-height: 60vh;
    padding: 0 20px;
    box-sizing: border-box;

    .label-title {
      padding: 0 20px 0 70px;
      position: relative;

      &::before {
        content: "";
        width: 100%;
        height: 1px;
        background: #ccc;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }

      span {
        padding: 5px 20px;
        border-radius: 18px;
        background: #a4a4a4;
        color: #fff;
        position: relative;
        z-index: 2;

        &::before,
        &::after {
          content: "";
          width: 7px;
          height: 7px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: #ccc;
          border-radius: 50%;
        }
        &::before {
          left: -20px;
        }
        &::after {
          right: -20px;
        }
      }
    }

    .list {
      padding: 25px 0;

      .item {
        padding: 20px 10px;
        border-bottom: 1px solid #eeeeee;
        display: flex;

        &:hover {
          background-color: #eee;
          cursor: pointer;
        }
        .img {
          width: 25%;
          flex-shrink: 0;
          height: 120px;
          margin-right: 10px;

          .post {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: 0.5s;
          }
        }
        .info {
          flex-grow: 1;
          max-width: 75%;
        }

        .title {
          font-size: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .intro {
          padding-top: 8px;
          color: #8a8a8a;
          font-size: 14px;
        }
        .time {
          font-size: 12px;
          color: #999999;
          padding-top: 8px;
        }
      }
    }
  }
}
</style>
